import React from 'react';
import { useTranslations } from '../translations/translations';
import { useFadeIn } from '../hooks/useFadeIn';

const Confidentiality = () => {
  const t = useTranslations();
  const [ref, isVisible] = useFadeIn(0.1);
  
  return (
    <section 
      id="confidentialite" 
      ref={ref}
      className={`fade-in-section ${isVisible ? 'is-visible' : ''}`}
      style={{ background: '#0a0a0a', padding: '10rem 0' }}
    >
      <div className="container-custom">
        <div style={{ maxWidth: '1000px', margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{
            fontSize: 'clamp(2.1rem, 9vw, 3.5rem)',
            fontWeight: 200, 
            marginBottom: '3rem',
            letterSpacing: '-0.02em',
            lineHeight: 1.2
          }}>
            {t.confidentiality.title}
          </h2>
          
          <div style={{ 
            fontSize: '1.2rem', 
            color: '#a3a3a3',
            lineHeight: 1.9,
            fontWeight: 300,
            marginBottom: '5rem'
          }}>
            <p>
              {t.confidentiality.description}
            </p>
          </div>

          <div className="confidentiality-stats" style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '4rem',
            marginTop: '5rem'
          }}>
            <div>
              <div style={{ 
                fontSize: '3rem', 
                fontWeight: 200, 
                marginBottom: '1rem',
                color: '#ffffff'
              }}>24/7</div>
              <div style={{ 
                fontSize: '0.9rem', 
                color: '#737373',
                letterSpacing: '1px',
                textTransform: 'uppercase'
              }}>Surveillance Continue</div>
            </div>
            
            <div>
              <div style={{ 
                fontSize: '3rem', 
                fontWeight: 200, 
                marginBottom: '1rem',
                color: '#ffffff'
              }}>100%</div>
              <div style={{ 
                fontSize: '0.9rem', 
                color: '#737373',
                letterSpacing: '1px',
                textTransform: 'uppercase'
              }}>Confidentialité</div>
            </div>
            
            <div>
              <div style={{ 
                fontSize: '3rem', 
                fontWeight: 200, 
                marginBottom: '1rem',
                color: '#ffffff'
              }}>15+</div>
              <div style={{ 
                fontSize: '0.9rem', 
                color: '#737373',
                letterSpacing: '1px',
                textTransform: 'uppercase'
              }}>Années d'Expertise</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Confidentiality;
